import { useSelectedDealer } from "components";
import { useTypedQuery } from "hooks";
import { WebhooksQueryKeys } from "modules/WebhooksDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Webhook } from "models";

const sortWebhooks = (webhooks: Webhook[]) => webhooks.sort((a, b) => a.id - b.id);

export const useWebhooksQuery = () => {
  const { selectedDealer } = useSelectedDealer();

  return useTypedQuery({
    queryKey: WebhooksQueryKeys.webhooks,
    queryFn: async () =>
      (await ApiInstance.post(WebhooksQueryKeys.webhooks.endpoint, { dealer_id: selectedDealer?.id || 0 }, WebhooksQueryKeys.webhooks.baseUrl)).data.webhooks,
    enabled: false,
    refetchOnDependencies: [selectedDealer?.id],
    select: sortWebhooks
  });
};
